import React, { useState } from "react";

const CustomFilter = ({
  onSelect,
  filtersData = [],
  customClass = "",
  selectedTab,
}) => {
  return (
    <div className={`custom_filter_container ${customClass}`}>
      {filtersData?.map((el, index) => {
        return (
          <div
            className={`custom__filter ${
              selectedTab === el.value ? "selected" : ""
            }`}
            onClick={() => onSelect(el.value)}
            key={index}
          >
            <p key={index}>{el.title}</p>
            <div
              className="bottom_tag"
              style={{
                opacity: selectedTab === el.value ? 1 : 0, // Show only for selected
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CustomFilter;
